module.exports = __webpack_public_path__ + "static/img/3bg_18.0d2fe65.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/3bg_18.png
// module id = 685
// module chunks = 1